module.exports = __webpack_public_path__ + "img/times.61739257.svg";